<template>
  <div
    v-if="hasPromoCode"
    @click="isDisabled ? needPromo = false : needPromo = !needPromo"
    class="vz-order-total-price-promo pdf-order-section-hide"
    :class="[
      {'vz-order-total-price-promo--active': needPromo},
      {'vz-order-total-price-promo--disabled': isDisabled}
      ]"
  >
    <vz-icon
      class="vz-order-total-price-promo-icon"
      variant="primary"
      size="18"
      url="/svg/star-percent.svg"
      no-masked-icon
    />

    <div class="vz-order-total-price-promo-title">
      У меня есть промокод
    </div>

    <transition name="fade">
      <div
        v-if="needPromo"
        class="vz-order-total-price-promo-flex"
      >
        <vz-input
          v-model="editPromocode"
          class="vz-order-total-price-promo-input"
          placeholder="Введите промокод"
          @keyup.enter="applyPromocodeEdit"
          @click.stop
        />

        <vz-button
          class="vz-order-total-price-promo-but"
          big
          variant="primary"
          @click.stop="applyPromocodeEdit"
        >
          Применить
        </vz-button>
      </div>
    </transition>
  </div>
</template>

<script lang="ts" setup>
import {orderEditPromocode} from "~/api/order";
import {toRefs} from "@vue/reactivity";
import {useLayoutStore} from "~/stores/personal/layout";
import {useOrderStore} from "~/stores/order";
import VzButton from "~/components/ui-kit/vz-button.vue";
import VzInput from "~/components/ui-kit/vz-input.vue";

const props = defineProps({
  isDisabled: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update-order'])
const orderStore = useOrderStore()
const {pageLoader} = toRefs(useLayoutStore())
const needPromo = ref(false)
const editPromocode = ref('')

const hasPromoCode = computed(() => {
  return orderStore.orderForm?.meta?.isPromocodeAvailable
})

async function applyPromocodeEdit() {
  if (props.isDisabled) {
    return
  }

  try {
    pageLoader.value = true
    const res = await orderEditPromocode({orderGuid: orderStore.orderView?.meta?.guid, promocode: editPromocode.value})
    pageLoader.value = false

    if(res.services.length) {
      emit('update-order')
    }
  } catch (e) {
    pageLoader.value = false
  }
}
</script>

<style scoped lang="scss">

</style>
